exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media print{body *{visibility:hidden}#PurchaseEnquiryUpdateModalView,#PurchaseEnquiryUpdateModalView *{visibility:visible}#PurchaseEnquiryUpdateModalView::-webkit-scrollbar{width:0!important}#PurchaseEnquiryUpdateModalView:last-child{page-break-after:auto;page-break-before:none}#PurchaseEnquiryUpdateModalView{position:relative;margin-top:-210%;height:100%;width:400mm!important}button{display:none}}.el-switch__label *{font-size:18px;font-weight:700}.el-switch__label.is-active{color:#fc3317}", ""]);

// exports
